import React from 'react'

/**
 * Embrulha `trecho` dentro de `frase` num <span className="realce">, para
 * títulos/parágrafos ficarem bicolores (branco + azul), o padrão tipográfico
 * da identidade "Nauta" — ver `.realce` em global.css.
 *
 * Extraído para módulo próprio em 11/08 quando a 2ª seção (SecaoSobre) foi
 * precisar da mesma função que já vivia em SecaoPalco.
 *
 * NÃO é a mesma função que `comDestaque` de SecaoHero.jsx — aquela embrulha
 * em `<strong>` (negrito), não `<span className="realce">` (cor), porque a
 * tagline do hero alimenta também `<meta name="description">`, onde uma tag
 * de cor não faria sentido nenhum. Duas funções de propósito diferente que
 * por coincidência têm o mesmo nome; não unificar.
 *
 * `frase` continua sendo uma string simples nos dados (evento.js) e no
 * Builder. Quem quiser o destaque recorta o trecho aqui, na hora de
 * renderizar; sem `trecho`, ou se ele não existir na frase, o texto sai
 * inteiro e sem cor — nunca quebra.
 */
export function comDestaque(frase, trecho) {
  if (!trecho) return frase

  const inicio = frase.indexOf(trecho)
  if (inicio === -1) return frase

  return [
    frase.slice(0, inicio),
    <span key="destaque" className="realce">{trecho}</span>,
    frase.slice(inicio + trecho.length),
  ]
}
